import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import About from './AboutSection';
import Course from './CourseSection';
import FunFact from './FunFactSection';
import Team from './TeamSection';
import Testimonial from './TestimonialSection';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';

const AboutMain = () => {
  const content = useCollections('programs', 'staff', 'testimonials', 'pages');
  if (content.loading || content.error) return <DataState state={content} />;

  return (
    <main>
      <Breadcrumb title="about us" />
      <About />
      <FunFact />
      <Testimonial />
      <Course />
      <Team />
    </main>
  );
};
export default AboutMain;
